<template>
    <section id="theContent" class="mt-5 mb-5">
        <div class="container internship-header-wrapper">
            <!--<div class="filter-category">-->
            <!--    <span>Kategorie</span>-->
            <!--    <div class="filter-wrapper">-->
            <!--        <div class="filter-buttons">-->
            <!--            <button-->
            <!--                v-for="topic in interntopics"-->
            <!--                :key="topic.id"-->
            <!--                class="filter-button"-->
            <!--                :class="{ 'active': topic.active }"-->
            <!--                @click="topic.active = !topic.active"-->
            <!--            >-->
            <!--                {{ topic.name }}-->
            <!--            </button>-->
            <!--        </div>-->
            <!--    </div>-->
            <!--</div>-->

            <div class="filter-category">
                <span>Kategorie</span>
                <div class="filter-wrapper">
                    <Listbox v-model="selectedTopics" multiple>
                        <div class="relative z-10">
                            <ListboxButton
                                class="listbox-button"
                            >
                                            <span
                                                :class="[
                                                    activeTopics.length > 0 ? 'text-darkestblue font-bold' : 'text-darkgray font-normal',
                                                    'block truncate',
                                                ]"
                                            >
                                                {{ activeTopics.length > 0 ? selectedTopics.map((topic) => topic.name).join(', ') : "Alle" }}
                                            </span>
                                <span
                                    class="icon-wrapper"
                                >
                                                <ChevronUpDownIcon
                                                    class="icon"
                                                    aria-hidden="true"
                                                />
                                            </span>
                            </ListboxButton>

                            <transition
                                leave-active-class="transition duration-100 ease-in"
                                leave-from-class="opacity-100"
                                leave-to-class="opacity-0"
                            >
                                <ListboxOptions
                                    class="listbox-options"
                                >
                                    <ListboxOption
                                        v-slot="{ active, selected }"
                                        v-for="topic in interntopics"
                                        :key="topic.id"
                                        :value="topic"
                                        @click="topic.active = !topic.active"
                                        as="template"
                                        class="listbox-option"
                                    >
                                        <li
                                            :class="[
                                                    active ? 'bg-midblue' : '',
                                                    'relative cursor-default select-none py-2 pl-10 pr-4',
                                                ]"
                                        >
                                                <span class="block truncate">
                                                    {{ topic.name }}
                                                </span>
                                            <span
                                                v-if="selected"
                                                class="selected-icon-wrapper"
                                            >
                                                    <CheckIcon class="selected-icon" aria-hidden="true"/>
                                                </span>
                                        </li>
                                    </ListboxOption>
                                </ListboxOptions>
                            </transition>
                        </div>
                    </Listbox>
                </div>
            </div>


            <div class="filter-company-search">
                <div class="filter-company">
                    <span>Firma</span>
                    <div class="filter-wrapper">
                        <Listbox v-model="selectedCompanies" multiple>
                            <div class="relative z-10">
                                <ListboxButton
                                    class="listbox-button"
                                >
                                            <span
                                                :class="[
                                                    activeCompanies.length > 0 ? 'text-darkestblue font-bold' : 'text-darkgray font-normal',
                                                    'block truncate',
                                                ]"
                                            >
                                                {{ activeCompanies.length > 0 ? selectedCompanies.map((company) => company.name).join(', ') : "Alle" }}
                                            </span>
                                    <span
                                        class="icon-wrapper"
                                    >
                                                <ChevronUpDownIcon
                                                    class="icon"
                                                    aria-hidden="true"
                                                />
                                            </span>
                                </ListboxButton>

                                <transition
                                    leave-active-class="transition duration-100 ease-in"
                                    leave-from-class="opacity-100"
                                    leave-to-class="opacity-0"
                                >
                                    <ListboxOptions
                                        class="listbox-options"
                                    >
                                        <ListboxOption
                                            v-slot="{ active, selected }"
                                            v-for="company in interncompanies"
                                            :key="company.id"
                                            :value="company"
                                            @click="company.active = !company.active"
                                            as="template"
                                            class="listbox-option"
                                        >
                                            <li
                                                :class="[
                                                    active ? 'bg-midblue' : '',
                                                    'relative cursor-default select-none py-2 pl-10 pr-4',
                                                ]"
                                            >
                                                <span class="block truncate">
                                                    {{ company.name }}
                                                </span>
                                                <span
                                                    v-if="selected"
                                                    class="selected-icon-wrapper"
                                                >
                                                    <CheckIcon class="selected-icon" aria-hidden="true"/>
                                                </span>
                                            </li>
                                        </ListboxOption>
                                    </ListboxOptions>
                                </transition>
                            </div>
                        </Listbox>
                    </div>
                </div>

                <div class="filter-search-reset">
                    <input class="filter-search" type="search" v-model="searchQuery" placeholder="Suchen …">
                    <div class="filter-reset">
                        <span v-show="activeCompanies.length || activeTopics.length || searchQuery.length"
                              @click="resetFilters">Filter zurücksetzen</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="container itemGrid">
            <div
                ref="masonryContainer"
                class="row masonryContainer"
                :class="{ 'filtering': filterChanged }"
            >
                <div
                    v-for="card in filteredCards"
                    :key="card.id"
                    v-show="card.show"
                    class="col col-md-6 item"
                >
                    <internship-card :card="card" />
                </div>
            </div>
            <button v-if="hasMoreCardsToShow" @click="loadMorePosts" class="btn brightBlue iconPlus btnLoadMore">
                Mehr laden
            </button>
        </div>
    </section>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, nextTick, reactive, computed } from 'vue/dist/vue.esm-bundler';
import internshipCard from "./internshipCard";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
} from '@headlessui/vue'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid'

const filterChanged = ref(false);
const cards = ref([]);
const interntopics = ref([]);
const selectedTopics = ref([]);
const activeTopics = ref([]);
const interncompanies = ref([]);
const activeCompanies = ref([]);
const selectedCompanies = ref([]);
const searchQuery = ref('');
const masonry = ref(null);
const masonryContainer = ref(null);
const postsPerPage = 9;
let page = 1;

onMounted(async() => {
    await loadCards();
    initMasonry();
});

const filteredCards = computed(() => {
    let tempCards = [...cards.value];

    activeTopics.value = interntopics.value.filter((topic) => topic.active);
    activeCompanies.value = interncompanies.value.filter((company) => company.active);

    if (activeTopics.value.length) {
        const activeTopicIds = activeTopics.value.map((topic) => topic.id);
        tempCards = tempCards.filter((card) => {
            const cardTopicIds = card.interntopics?.map((topic) => topic.id);
            return cardTopicIds?.some((id) => activeTopicIds.includes(id));
        });
    }

    if (activeCompanies.value.length) {
        const activeCompanyIds = activeCompanies.value.map((company) => company.id);
        tempCards = tempCards.filter((card) => activeCompanyIds.includes(card.acf.internshipCompany.ID));
    }

    if (searchQuery.value) {
        tempCards = tempCards.filter((card) => {
            return card.title.rendered.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
                (card.acf.intershipFacts && card.acf.intershipFacts.toLowerCase().includes(searchQuery.value.toLowerCase())) ||
                (card.acf.internshipCompany && card.acf.internshipCompany.post_title.toLowerCase().includes(searchQuery.value.toLowerCase()));
        });
    }

    return tempCards;
});

watch(filteredCards, () => {
    const postsToShowCount = postsPerPage * page;
    const visibleCards = filteredCards.value.slice(0, postsToShowCount);

    cards.value.forEach(card => {
        card.show = false;
    });

    visibleCards.forEach(card => {
        card.show = true;
    });

    nextTick(() => {
        filterChanged.value = true;

        masonry.value?.destroy();
        initMasonry();

        setTimeout(() => {
            filterChanged.value = false;
        }, 250);
    });
});

watch(cards, (newCards, oldCards) => {
    if (newCards.length > oldCards.length) {
        nextTick(() => {
            masonry.value?.destroy();
            initMasonry();

            cards.value.forEach((card) => {
                card.interntopics?.forEach((topic) => {
                    if (!interntopics.value.find((t) => t.id === topic.id)) {
                        interntopics.value.push(topic);
                    }
                });

                if (card.acf.internshipCompany && !interncompanies.value.find((c) => c.id === card.acf.internshipCompany.ID)) {
                    interncompanies.value.push({
                        id: card.acf.internshipCompany.ID,
                        name: card.acf.internshipCompany.post_title,
                        active: false,
                    });
                }
            });

            interncompanies.value = sortByName(interncompanies.value);
            interntopics.value = sortByName(interntopics.value);
        });
    }
});

async function loadCards() {

    let response = await fetch(zwi.rootapiurl + 'wp/v2/internship?per_page=9999');
    let data = await response.json();

    if (data) {
        const newCards = data.map((card, index) => ({
            ...card,
            show: index + 1 <= postsPerPage,
        }));

        cards.value = newCards;

        // Populate interncompanies
        newCards.forEach((card) => {
            if (card.acf.internshipCompany && !interncompanies.value.find((c) => c.id === card.acf.internshipCompany.ID)) {
                interncompanies.value.push({
                    id: card.acf.internshipCompany.ID,
                    name: card.acf.internshipCompany.post_title,
                    active: false,
                });
            }
        });

        interncompanies.value = sortByName(interncompanies.value);
    }

    page++;
}

function loadMorePosts() {
    page++;

    const postsShowCount = postsPerPage * page;

    const visibleCardIds = filteredCards.value.slice(0, postsShowCount).map(card => card.id);

    cards.value.forEach(card => {
        card.show = visibleCardIds.includes(card.id);
    });

    imagesLoaded(masonryContainer.value, () => {
        masonry.value.layout();
    });
}

function initMasonry() {
    if (masonryContainer.value) {
        imagesLoaded(masonryContainer.value, () => {
            masonry.value = new Masonry(masonryContainer.value, {
                itemSelector: '.item',
                columnWidth: '.item',
                percentPosition: true,
            });
        });
    }
}

function resetFilters() {
    interntopics.value.forEach((topic) => {
        topic.active = false;
    });
    interncompanies.value.forEach((company) => {
        company.active = false;
    });
    searchQuery.value = '';
}

const hasMoreCardsToShow = computed(() => {
    const visibleFilteredCardsCount = filteredCards.value.filter(card => card.show).length;
    return filteredCards.value.length > 0 && visibleFilteredCardsCount < filteredCards.value.length;
});

function sortByName(array) {
    return array.sort((a, b) => a.name.localeCompare(b.name));
}

onUnmounted(() => {
    if (masonry.value) {
        masonry.value.destroy();
    }
});

watch([activeTopics, activeCompanies, searchQuery], () => {
    page = 1;
});
</script>

<style lang="scss">
@import "../../../scss/hm/hmVars";

.btnLoadMore {
    display: block;
    margin-left: auto;
    margin-right: auto;
}

.internship-header-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 1.5rem;
    margin-bottom: 20px;

    @media (min-width: 768px) {
        flex-direction: row;
        flex-wrap: wrap;
        margin-bottom: 50px;
    }
}

.filter-category {
    @media (min-width: 768px) {
        width: 48%;
    }

    @media (min-width: 1024px) {
        width: calc(50% - 0.75rem);
    }
}

.filter-company {
    width: 100%;

    @media (min-width: 1024px) {
        width: calc(60% - 0.75rem);
    }
}

.filter-company-search {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;

    @media (min-width: 768px) {
        width: calc(50% - 0.75rem);
        gap: 1.5rem;
    }

    @media (min-width: 1024px) {
        flex-direction: row;
    }
}

.filter-category, .filter-company {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;

    span {
        //color: $darkestblue;
        margin-top: 0;
        margin-bottom: 0;
    }

    > span {
        font-weight: 700;
    }

    .filter-wrapper {
        .filter-buttons {
            display: flex;
            gap: 0.4rem;
            flex-wrap: wrap;
        }
    }

    // Not needed anymore. But usable for future filter buttons.
    //.filter-buttons {
    //    padding: 0;
    //    width: 100%;
    //
    //    .filter-button {
    //        display: flex;
    //        align-items: center;
    //        justify-content: center;
    //        color: $darkestblue;
    //        font-weight: 700;
    //        font-size: 16px;
    //        background-color: #f5f5f5;
    //        padding: 0.6rem 1rem;
    //        border: 2px solid #e5e5e5;
    //        transition-property: color, border-color;
    //        transition: .3s ease;
    //
    //        &.active,
    //        &:hover {
    //            border-color: $darkblue;
    //        }
    //
    //        &.active {
    //            background-color: $midblue;
    //        }
    //    }
    //}
}

.filter-search-reset {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    justify-content: space-between;
    width: 100%;

    @media (min-width: 1024px) {
        width: calc(40% - 0.75rem);
    }

    .filter-search {
        padding: 0.6rem 1rem;
        border: 2px solid #e5e5e5;


        &:focus {
            outline: 2px solid $darkblue;
            outline-offset: -2px;
        }

        &::placeholder {
            color: $darkgray;
        }

        @media (min-width: 1024px) {
            margin-top: 30px;
        }
    }

    .filter-reset {
        text-align: right;

        &:hover {
            cursor: pointer;
            color: $darkestblue;
            transition: color .3s ease;
        }
    }
}

.masonryContainer {
    transition: opacity .5s ease;

    &.filtering {
        transition-duration: 0s;
        opacity: 0;
    }
}

// Listbox Styles
.listbox-button {
    position: relative;
    padding: 0.6rem 1.5rem 0.6rem 1rem;
    font-size: inherit;
    width: 100%;
    text-align: left;
    background-color: #ffffff;
    border: 2px solid #e5e5e5;
    cursor: default;

    @media (min-width: 640px) {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    span {
        font-size: 16px;
    }

    .icon-wrapper {
        display: flex;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        padding-right: 0.5rem;
        align-items: center;
        pointer-events: none;

        .icon {
            width: 1.25rem;
            height: 1.25rem;
            color: #9CA3AF;
        }
    }
}

.listbox-options {
    overflow: auto;
    position: absolute;
    padding: 0.5rem 0;
    margin-top: 0.25rem;
    width: 100%;
    list-style-type: none;
    color: $darkestblue;
    background-color: #f5f5f5;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);

    .listbox-option {
        span {
            font-weight: 700;
        }

        .selected-icon-wrapper {
            display: flex;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            padding-left: 0.75rem;
            align-items: center;

            .selected-icon {
                width: 1.25rem;
                height: 1.25rem;
            }
        }
    }

}

.relative {
    position: relative;
}

.z-10 {
    z-index: 10;
}

.cursor-default {
    cursor: default;
}

.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}

.block {
    display: block;
}

.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bg-midblue {
    background-color: $midblue;
}

.text-darkestblue {
    color: $darkestblue;
}

.text-darkgray {
    color: $darkgray;
}

.font-normal {
    font-weight: 400;
}

.font-bold {
    font-weight: 700;
}

.select-none {
    user-select: none;
}

.pl-10 {
    padding-left: 2.5rem;
}

.pr-4 {
    padding-right: 1rem;
}
</style>
